import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const multipartHeaders = () => {
  const headers = { ...authHeader({ contentType: "multipart/form-data" }) };
  delete headers["Content-Type"];
  return headers;
};

const notePayload = (values = {}) => {
  const payload = { note: values.note || "" };
  if (values.client_id !== undefined && values.client_id !== null && values.client_id !== "") {
    payload.client_id = Number(values.client_id);
  }
  return payload;
};

const create = (values) => {
  const action = "afterlogin/clientnote/store";
  return axios.post(API_URL + action, notePayload(values), { headers: authHeader() });
};

const update = (values) => {
  const action = "afterlogin/clientnote/update/" + values.id;
  return axios.post(API_URL + action, notePayload(values), { headers: authHeader() });
};

const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/clientnote/view", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const deleted = (values) => {
  const action = `afterlogin/clientnote/delete/${values.id}`;
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const lock = (values = {}) => {
  const action = `afterlogin/clientnote/lock/${values.id}`;
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const unlock = (values = {}) => {
  const action = `afterlogin/clientnote/unlock/${values.id}`;
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const clientnoteimport = (values) => {
  const action = `afterlogin/client/clientimportnote`;
  const formData = new FormData();
  for (let value in values || {}) {
    formData.append(value, values[value]);
  }
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

const clientnoteexport = () => {
  return Promise.reject({
    response: {
      status: 501,
      data: { message: "Client note export is not supported by the Flask API." },
    },
  });
};

const samplenoteexports = (values) => {
  const action = `common/sampleclientnoteexport`;
  return axios.post(API_URL + action, values || {}, {
    headers: authHeader(),
    responseType: "blob",
  });
};

const clientnoteApiController = {
  create,
  update,
  view,
  deleted,
  lock,
  unlock,
  clientnoteimport,
  samplenoteexports,
  clientnoteexport
};
export default clientnoteApiController;
